var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('nav-bar'),_vm._v(" "),_c('div',{staticClass:"fixedHeight"}),_vm._v(" "),_c('main',[_c('router-view')],1),_vm._v(" "),_c('vFooter'),_vm._v(" "),_c('i',{staticClass:"iconfont icon-huidaodingbu",style:({ opacity: _vm.scrollTop > 500 ? 1 : 0 }),on:{"click":_vm.scrollToTop}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dadedd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 